import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { notification,Icon } from 'antd';

import { ReactComponent as successIcon } from '../icons/icon-success.svg';
import { ReactComponent as errorIcon } from '../icons/icon-error.svg';

class Notification extends React.Component {  
  
  componentDidUpdate() {
    var { t } = this.props;
    var { isUpdated,isOptOut,updateSuccess } = this.props;
    
    if(isUpdated && isOptOut) {
      if(updateSuccess) {
        notification['success']({
          message: t('notificationThankYou'),
          description: t('notificationUpdated'),
          className: 'notificationSuccess notificationIcon',
          icon: <Icon component={successIcon}/>
        });
      } else {
        notification['error']({
          message: t('notificationError'),
          description: t('notificationErrorMessage'),
          className: 'notificationError notificationIcon',
          icon: <Icon component={errorIcon}/>
        });
      }
    }
  }

  render() {
    return '';
  }
}

const mapStateToProps = state => ({
  isOptOut: state.status.saved,
  isUpdated: state.status.isUpdated,
  updateSuccess: state.status.updateSuccess
});

export default connect(mapStateToProps,{})(withTranslation()(Notification));